<template>

    <footer class="site-footer">
        <div class="container pt-5 pb-1">

            <div class="row gy-4">

                <!-- Brand -->
                <div class="col-lg-4">
                    <div class="footer-brand">
                        <h3 class="logo">
                            <a class="" href="#">
                                <img src="https://belizeontop.com/wp-content/uploads/2026/01/footer_logo-1.png" alt="Belize On Top" class="logo">
                            </a>
                        </h3>
                        <p>
                            Get around with ease using BelizeonTop! Enjoy budget-friendly, dependable golf cart rentals, hassle-free booking, doorstep delivery, and round-the-clock support.

                        </p>

                        <div class="clear"></div>
                        <h5 class="footer-title" style="padding-top:15px;">Contact Info</h5>
                        <div class="footer-contact-info">
                            <div class="footer-address">
                                <span><i class="feather-phone-call"></i></span>
                                <div class="addr-info">
                                    <p><a href="tel:{{OurPhone}}">{{OurPhone}}</a></p>
                                </div>

                                <span style=" background: #075e54; margin-left:15px;"><i class="fab fa-whatsapp"></i></span>
                                <div class="addr-info">
                                    <p><a href="javascript:void(0);">{{OurPhone}}</a></p>
                                </div>
                            </div>
                            <div class="footer-address last">
                                <span><i class="feather-mail"></i></span>
                                <div class="addr-info">
                                    <a href="mailto:{{OurEmail}}">{{OurEmail}}</a>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>



                <!-- Categories -->
                <div class="col-lg-4 ">
                    <div class="catfooter">
                        <h5 class="footer-title">Links</h5>
                        <div class="row">
                            <div class="col-md-12">
                                <ul class="footer-links">
                                    <li v-for="link in footerNavLinks">
                                        <router-link class="nav-link" :to="{ name: link.routeUrl,params:link.params}">{{link.displayText}}</router-link>
                                    </li>
                                </ul>
                            </div>
                            <div class="clear"></div>


                        </div>

                        <div id="desktopRating" class="footer-rating text-center">
                            <div class="stars"> ★★★★★ <span> Rated <strong>4.95/5.0</strong> </span></div>

                            <p>Based on feedback from <strong>1,750+</strong> clients   </p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4">
                    <div class="footer-contact footer-widget">


                        <div class="footer-social-widget">
                            <h5 class="footer-title"> Follow us on</h5>
                            <SocialMediaIconComponent></SocialMediaIconComponent>


                            <!--<ul class="nav-social">
            <li>
                <a href="javascript:void(0)"><i class="fa-brands fa-facebook-f fa-facebook fi-icon"></i></a>
            </li>
            <li>
                <a href="javascript:void(0)"><i class="fab fa-instagram fi-icon"></i></a>
            </li>
            <li>
                <a href="javascript:void(0)"><i class="fab fa-behance fi-icon"></i></a>
            </li>
            <li>
                <a href="javascript:void(0)"><i class="fab fa-twitter fi-icon"></i> </a>
            </li>
            <li>
                <a href="javascript:void(0)"><i class="fab fa-linkedin fi-icon"></i></a>
            </li>
        </ul>-->
                        </div>

                        <div class="update-form">
                            <!--<form action="#">
            <span><i class="feather-mail"></i></span>
            <input type="email" class="form-control" placeholder="Enter You Email Here">
            <button type="submit" class="btn btn-subscribe"><span><i class="feather-send"></i></span></button>
        </form>-->

                            <newsletter></newsletter>
                        </div>

                        <div id="mobileRating" class="footer-rating text-center">
                            <div class="stars"> ★★★★★ <span> Rated <strong>4.95/5.0</strong> </span></div>

                            <p>Based on feedback from <strong>1,750+</strong> clients   </p>
                        </div>




                    </div>
                </div>
            </div>
        </div>
        <!-- Newsletter -->
        <!--<div class="col-lg-3">
            <h5 class="footer-title">Follow us on</h5>
            <div class="social-icon" data-color="default" data-icons-type="simple">
                <a href="https://www.facebook.com/belizeontop" data-network="facebook" aria-label="Facebook" target="blank">
                    <span class="ct-icon-container">
                        <svg width="20px" height="20px" viewBox="0 0 20 20" aria-hidden="true">
                            <path d="M20,10.1c0-5.5-4.5-10-10-10S0,4.5,0,10.1c0,5,3.7,9.1,8.4,9.9v-7H5.9v-2.9h2.5V7.9C8.4,5.4,9.9,4,12.2,4c1.1,0,2.2,0.2,2.2,0.2v2.5h-1.3c-1.2,0-1.6,0.8-1.6,1.6v1.9h2.8L13.9,13h-2.3v7C16.3,19.2,20,15.1,20,10.1z"></path>
                        </svg>
                    </span>
                </a>
                <a href="https://x.com/belizeontop" data-network="twitter" aria-label="X (Twitter)" target="blank">
                    <span class="ct-icon-container">
                        <svg width="20px" height="20px" viewBox="0 0 20 20" aria-hidden="true">
                            <path d="M2.9 0C1.3 0 0 1.3 0 2.9v14.3C0 18.7 1.3 20 2.9 20h14.3c1.6 0 2.9-1.3 2.9-2.9V2.9C20 1.3 18.7 0 17.1 0H2.9zm13.2 3.8L11.5 9l5.5 7.2h-4.3l-3.3-4.4-3.8 4.4H3.4l5-5.7-5.3-6.7h4.4l3 4 3.5-4h2.1zM14.4 15 6.8 5H5.6l7.7 10h1.1z"></path>
                        </svg>
                    </span>
                </a>
                <a href="https://www.instagram.com/belizeontop/" data-network="instagram" aria-label="Instagram" target="blank">
                    <span class="ct-icon-container">
                        <svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true">
                            <circle cx="10" cy="10" r="3.3"></circle>
                            <path d="M14.2,0H5.8C2.6,0,0,2.6,0,5.8v8.3C0,17.4,2.6,20,5.8,20h8.3c3.2,0,5.8-2.6,5.8-5.8V5.8C20,2.6,17.4,0,14.2,0zM10,15c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S12.8,15,10,15z M15.8,5C15.4,5,15,4.6,15,4.2s0.4-0.8,0.8-0.8s0.8,0.4,0.8,0.8S16.3,5,15.8,5z"></path>
                        </svg>
                    </span>
                </a>
                <a href="https://www.youtube.com/channel/UCIzGf_87vu0GaDkgqSpc_xA" data-network="youtube" aria-label="youtube" target="blank">
                    <span class="ct-icon-container">
                        <svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true">
                            <path d="M15,0H5C2.2,0,0,2.2,0,5v10c0,2.8,2.2,5,5,5h10c2.8,0,5-2.2,5-5V5C20,2.2,17.8,0,15,0z M14.5,10.9l-6.8,3.8c-0.1,0.1-0.3,0.1-0.5,0.1c-0.5,0-1-0.4-1-1l0,0V6.2c0-0.5,0.4-1,1-1c0.2,0,0.3,0,0.5,0.1l6.8,3.8c0.5,0.3,0.7,0.8,0.4,1.3C14.8,10.6,14.6,10.8,14.5,10.9z"></path>
                        </svg>
                    </span>
                </a>
            </div>

            <h5 class="footer-title mt-4">Newsletter</h5>
            <form>
                <input type="text" class="form-control footer-input mb-3" placeholder="Full Name">
                <input type="email" class="form-control footer-input mb-3" placeholder="Your Email*">
                <button class="btn footer-btn w-100">
                    Get Monthly Offers & Deals
                </button>
            </form>
        </div>-->
        <!--</div>
        </div>-->
        <!-- Bottom Bar -->
        <div class="footer-bottom">
            <div class="container d-flex flex-column flex-md-row justify-content-between align-items-center">
                <p class="mb-2 mb-md-0">
                    © 2026 – BelizeonTop. All Rights Reserved.
                </p>


                <!--<div class="bottom-links">
        <a href="#">About</a>
        <a href="#">Privacy Policy</a>
        <a href="#">Cookies Policy</a>
        <a href="#">Terms & Conditions</a>
    </div>-->



            </div>
        </div>

    </footer>

    <div style="position: fixed;z-index: 1000;bottom: 15px;left: 15px;">
        <a href="https://wa.me/+5016772900" target="_blank">
            <img data-src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" width="60" height="60" src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" class=" lazyloaded" style="--smush-placeholder-width: 60px; --smush-placeholder-aspect-ratio: 60/60;"><noscript><img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" width="60" height="60"></noscript>
        </a>
        </div>

</template>

<script>
    import SocialMediaIconComponent from '@/views/SocialMediaIcons/socialMediaIcons.vue'
    import newsletter from '@/views/NewsLetter/newsletter.vue'
    export default {
        name: 'FooterVue',
        props: ["footerNavLinks", "serviceLinks", "FooterLogoDescription", "OurAddress", "OurEmail", "OurPhone", "Copyrights","secondaryLogoLink"],
        components: {
            SocialMediaIconComponent, newsletter
        },
        data() {
            return {
                companyLogo: '',
                companyName: ''
            }
        },
        created() {
            this.getCompanyLogo();
            this.companyName = localStorage.getItem('companyName')
        },
        methods: {
            getCompanyLogo() {
                let logoUrl = localStorage.getItem('companyLogo');
                this.companyLogo = (this.$filters.IsNull(logoUrl, 'null') == 'null') ? require('../../../../../assets/images/logo/default-logo.png') : logoUrl;
            }
        }

    }
</script>